import React from 'react'
import { Body, PrimaryLinkStyle } from 'components/styled/typography'
import { Icon } from 'components/styled/icon'
import styled from 'styled-components'
import { ThemeColor } from 'theme/colors'

interface ActionRemoveProps {
  onClick: () => void
  children?: React.ReactNode | string
  color?: ThemeColor
}

const Text = styled(Body)`
  color: ${({ theme, color }) => color && `${theme.color[color]} !important`};
  ${PrimaryLinkStyle};
  && {
    margin-bottom: 0;
  }
`

const ActionButton = styled.button`
  display: flex;
  align-items: center;
  padding: 0 ${({ theme }) => theme.space.s4};
  height: ${({ theme }) => theme.space.s32};
  line-height: ${({ theme }) => theme.space.s24};

  &:hover,
  &:active {
    ${Text} {
      text-decoration: underline;
    }
  }
`

const ActionRemove = ({
  onClick,
  children,
  color = 'error110',
  ...props
}: ActionRemoveProps) => {
  return (
    <ActionButton type="button" onClick={onClick} {...props}>
      {children && (
        <Text pr="s4" color={color}>
          {children}
        </Text>
      )}
      <Icon size="s16" type="delete_outline" color={color} />
    </ActionButton>
  )
}

export default ActionRemove
